import ConsultingCompaniesContainer from "./ConsultingCompaniesContainer";
export default ConsultingCompaniesContainer;
